<template>
  <d-container fluid class="main-content-container px-4">
    <!-- Page Header -->
    <page-header title="Distribuidor" subTitle="Adicionar" />

    <!-- Default Light Table -->
    <d-row>
      <d-col>
        <d-card class="card-small mb-4">
          <div class="card-header border-bottom">
            <h6 class="m-0">Informações do distribuidor</h6>
          </div>
          <!-- Content -->
          <div class="p-4">
            <distributor-form />
          </div>
        </d-card>
      </d-col>
    </d-row>
  </d-container>
</template>

<script>
import { mapActions } from 'vuex';
import PageHeader from '_shared/PageHeader.vue';
import DistributorForm from '../components/DistributorForm.vue';

export default {
  name: 'admin-distributor-new',
  components: {
    PageHeader,
    DistributorForm,
  },
  data() {
    return {};
  },
  computed: {},
  methods: {
    ...mapActions(['setToggle', 'checkAdmin', 'getRegionList']),
  },
};
</script>
